import { propClassName } from '@/styles/TrendingMenu';
import { ClassNameProp, Component, ComponentProps } from '@/types/component';
import { cn } from 'lib/utils/cn';

export interface TrendingMenuHeadlineProps extends ComponentProps<'span'> {
  colors?: ClassNameProp<'default'>;
  size?: ClassNameProp<'default'>;
  variant?: ClassNameProp<'default'>;
}

export const TrendingMenuHeadlineComponent: Component<TrendingMenuHeadlineProps> = ({
  children,
  className,
  colors,
  size,
  variant,
  ...props
}) => {
  const colorsClassName = propClassName('headline_colors', colors, 'default');
  const sizeClassName = propClassName('headline_size', size, 'default');
  const variantClassName = propClassName('headline_variant', variant, 'default');
  const componentClassName = cn(colorsClassName, sizeClassName, variantClassName, className);

  return (
    <span className={componentClassName} {...props}>
      {children}
    </span>
  );
};
